module.exports = __webpack_public_path__ + "static/media/riley-lesb.f82100c3.jpg";